import { NoSsr } from '@cian/react-utils';
import { UIHeading2, LinkButton, ModalWindow, UIText2, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FoldersUnsupportedModal.css';
import smile from './assets/smile.png';

export interface IFoldersUnsupportedModalProps {
  isOpen: boolean;
  onClose(): void;
}

export const FoldersUnsupportedModal = ({ isOpen, onClose }: IFoldersUnsupportedModalProps) => (
  <NoSsr>
    <ModalWindow open={isOpen} onClose={onClose}>
      <div className={styles['container']}>
        <div className={styles['image']}>
          <Image width={64} src={smile} />
        </div>
        <div className={styles['header']}>
          <UIHeading2 textAlign="center">Подборки можно посмотреть в&nbsp;приложении</UIHeading2>
        </div>
        <div className={styles['subheader']}>
          <UIText2 textAlign="center">
            Но мы сохранили все объявления, которые вам понравились, в&nbsp;раздел Избранное
          </UIText2>
        </div>
        <div className={styles['button']}>
          <LinkButton href="https://cian.onelink.me/2426377992/5a271098">Открыть приложение</LinkButton>
        </div>
      </div>
    </ModalWindow>
  </NoSsr>
);
